import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type TemplateMetadata = {
	currentStep: number;
	workflow: string;
	selectedItem: any;
	source: string;
	containerRID?: string;
	drawerCloseType: string;
	drawerCloseHandlers: {
		close: (value?: any) => void;
		cancel: (value?: any) => void;
		callback: (value?: any) => void;
	};
	redirectPath?: string;
};

type State = {
	templateMetadata: TemplateMetadata;
};

type Actions = {
	updateTemplateMetadata: (data: Partial<TemplateMetadata> | TemplateMetadata) => void;
};

export type TemplateMetadataState = State & Actions;

const initialState = {
	templateMetadata: null,
};

export const createTemplateMetadataSlice: StateCreator<TemplateMetadataState> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		updateTemplateMetadata: (data: Partial<TemplateMetadata> | TemplateMetadata) => {
			const { templateMetadata } = get();

			set({
				templateMetadata: { ...templateMetadata, ...data },
			});
		},
	};
};
